import { useMutation } from "@tanstack/react-query";
import { userApi } from "@repo/api";
import { Logger } from "@saviynt/common";

export const useDisableUserTOTP = () => {
  const { mutate, isError, isSuccess } = useMutation({
    mutationFn: (payload: { email: string }) =>
      userApi.disableUserTOTP(payload),
    onError: (error) => {
      Logger.error("Error disabling user totp:", error);
    },
    onSuccess: (data) => {
      Logger.log("Successfully disabled user totp:", data);
    },
  });

  return { mutate, isError, isSuccess };
};
